<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { Text } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

interface Logo {
  imagePath: string;
  class?: string;
  /** Partner/brand name — used as the logo's alt text. */
  name?: string;
}

interface Props {
  href: string;
  logos: Logo[];
}

defineProps<Props>();

const emit = defineEmits<{
  startLearning: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div class="p-8 md:px-10 py-7 bg-white rounded-3xl h-full">
    <div class="md:flex md:justify-between md:align-items-center @container">
      <div class="md:flex-1">
        <h2 class="tracking-tight text-[clamp(3rem,8cqw,5.5rem)] font-semibold leading-none">
          <span class="text-nowrap">{{ t('unified.landing.realCareers.title.1') }}</span>
          <br>
          <span class="text-nowrap">{{ t('unified.landing.realCareers.title.2') }}</span>
        </h2>
        <div class="my-10 space-y-4">
          <Text>
            {{ t('unified.landing.realCareers.description.1') }}
          </Text>
          <Text>
            {{ t('unified.landing.realCareers.blinkySpeech') }}
          </Text>
          <Text>
            {{ t('unified.landing.realCareers.description.2') }}
          </Text>
        </div>
        <Button
          variant="secondary"
          size="lg"
          class="mb-10 w-full md:w-auto"
          as-child
          @click="emit('startLearning')"
        >
          <NuxtLink :to="href">
            {{ t('unified.landing.realCareers.ctaBtnLabel') }}
          </NuxtLink>
        </Button>
      </div>
      <div class="hidden md:flex md:flex-1 md:justify-end">
        <NuxtImg
          class="object-contain transform"
          src="/images/illustrations/real-careers.webp"
          alt=""
        />
      </div>
    </div>
    <KUICoreCarouselAutoScroll
      :speed="0.5"
      slide-class-name="min-w-0 flex-[0_0_auto] px-4"
      container-class-name="flex items-center"
      class-name="my-2"
    >
      <NuxtImg
        v-for="(logo, i) in logos"
        :key="i"
        :src="logo.imagePath"
        :alt="logo.name ?? ''"
        :class="logo.class"
      />
    </KUICoreCarouselAutoScroll>
  </div>
</template>
